import React from "react";

import {
   ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS,
   DRIVING_LICENSE_DURATION_OPTIONS,
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST,
   DRIVING_LICENSE_TYPE_OPTIONS,
   DVLA_MEDICAL_CONDITION_OPTIONS,
   OTHER_VEHICLE_USAGE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {ValidateStep3Data} from "@validators/van-insurance-form/step3-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import {
   CommonPolicyHolderClaimsForm
} from "@components/common/sub-components/insurance-form-parts/policy-holder-claims-form/common-policy-holder-claims-form";
import {
   CommonPolicyHolderConvictionsForm
} from "@components/common/sub-components/insurance-form-parts/policy-holder-convictions-form/common-policy-holder-convictions-form";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step3(
   {
      data,
      handlers,
      setCurrentStep,
      handlePolicyHolderAccidentPropChange,
      addPolicyHolderAccident,
      removePolicyHolderAccident,
      
      addPolicyHolderConviction,
      handlePolicyHolderConvictionPropChange,
      removePolicyHolderConviction
   }
) {
   
   const STEP = 3;
   
   const onPrevBtnClick = (event) => {
      
      setCurrentStep(STEP - 1);
      
   }
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep3Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(STEP + 1);
      }
      
      
   }
   
   const doesRequireLicenseDate = () => {
      
      return DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST.includes(data.drivingLicenseDuration);
      
   }
   
   const shouldDisplayAdditionalDrivingQualificationDate = () => {
      
      if (!data.additionalDrivingQualifications
         || !data.additionalDrivingQualifications.trim()) {
         return false;
      }
      
      return data.additionalDrivingQualifications !== 'No';
      
   }
   
   
   return (
      <div className='if-step-2'>
         
         <SectionHeading
            text="Driving history"
         />
         
         {/*
                License type ...
            */}
         
         <div className="row">
            
            {/* What tye of license do you have? */}
            
            <ScrollableDropdownBlock
               controlName="drivingLicenseType"
               containerCssClass="col-12 py-3 "
               labelText="Type of license"
               required={true}
               options={DRIVING_LICENSE_TYPE_OPTIONS}
               selectedValues={data.drivingLicenseType}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         {/*
                License number
            */}
         
         {/*{data.drivingLicenseType && (
                <DrivingLicenseNumber
                    data={data}
                    handlers={handlers}
                />
            )}*/}
         
         {/*
                License duration ...
            */}
         
         <div className="row">
            
            {/* How long have you held license? */}
            
            <ScrollableDropdownBlock
               controlName="drivingLicenseDuration"
               containerCssClass="col-12 py-3 "
               labelText="How long have you held license?"
               required={true}
               options={DRIVING_LICENSE_DURATION_OPTIONS}
               selectedValues={data.drivingLicenseDuration}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {doesRequireLicenseDate() && (
            
            <div className="row hidden-box">
               
               
               {/* Driving license date */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="Driving license date"
                  required={true}
                  controlName="drivingLicenseDate"
                  value={data.drivingLicenseDate}
                  onChange={handlers.onControlChange}
               />
            
            </div>
         
         )}
         
         
         {/*
                DVLA Medical conditions ...
            */}
         
         <div className="row">
            
            {/* Do you have any DVLA-reported medical conditions or disabilities? */}
            
            <ScrollableDropdownBlock
               controlName="dvlaMedicalConditions"
               containerCssClass="col-12 py-3 "
               labelText="Do you have any DVLA-reported medical conditions or disabilities?"
               required={true}
               options={DVLA_MEDICAL_CONDITION_OPTIONS}
               selectedValues={data.dvlaMedicalConditions}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         
         {/*
                Is born in UK?
            */}
         
         <div className="row">
            
            {/* Were you born in UK?  */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 "
               labelText="Were you born in UK? "
               required={true}
               controlName="isBornInUk"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.isBornInUk}
               onChange={handlers.onControlChange}
            />
         
         </div>
         
         {data.isBornInUk === 'No' && (
            <div className="row hidden-box">
               
               {/* When did you last become a UK resident? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="When did you last become a UK resident?"
                  required={true}
                  controlName="lastDateBecameUKResident"
                  value={data.lastDateBecameUKResident}
                  onChange={handlers.onControlChange}
               />
            </div>
         
         )}
         
         {/*
                Other vehicle usage ....
            */}
         
         <div className="row">
            
            {/* Use of any other vehicles */}
            
            <ScrollableDropdownBlock
               controlName="otherVehicleUsage"
               containerCssClass="col-12 py-3 "
               labelText="Use of any other vehicles"
               required={true}
               options={OTHER_VEHICLE_USAGE_OPTIONS}
               selectedValues={data.otherVehicleUsage}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         
         </div>
         
         {/*
                Do you have any unspent non-motoring criminal convictions?
            */}
         
         <div className="row">
            
            {/* Do you have any unspent NON-Motoring Criminal
                        Convictions? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 extra"
               labelText="Do you have any spent or unspent NON-Motoring Criminal
                        Convictions?"
               required={true}
               controlName="hasNonMotoringCriminalConvictions"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasNonMotoringCriminalConvictions}
               onChange={handlers.onControlChange}
            />
         
         
         </div>
         
         {/*
                Additional license qualifications ....
            */}
         
         <div className="row">
            
            {/* Any additional driving qualifications */}
            
            <ScrollableDropdownBlock
               controlName="additionalDrivingQualifications"
               containerCssClass="col-12 py-3 "
               labelText="Any additional driving qualifications"
               required={false}
               options={ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS}
               selectedValues={data.additionalDrivingQualifications}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         {/*
                If additional driving qualification is not empty,
                ask for qualification date ...
            */}
         
         {shouldDisplayAdditionalDrivingQualificationDate() && (
            <div className="row hidden-box mb-3">
               
               
               {/* What date was qualification obtained? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="What date was qualification obtained?"
                  required={shouldDisplayAdditionalDrivingQualificationDate()}
                  controlName="additionalDrivingQualificationDate"
                  value={data.additionalDrivingQualificationDate}
                  onChange={handlers.onControlChange}
               />
            
            
            </div>
         )}
         
         {/*
                Claims and convictions ...
            */}
         
         <SectionHeading
            text="Claims & convictions"
         />
         
         <CommonPolicyHolderClaimsForm
            sectionHeading={`Motor accidents or claims`}
            showSectionHeading={false}
            data={data}
            onChange={handlers.onControlChange}
            
            addPolicyHolderAccident={addPolicyHolderAccident}
            handlePolicyHolderAccidentPropChange={handlePolicyHolderAccidentPropChange}
            removePolicyHolderAccident={removePolicyHolderAccident}
         />
         
         <CommonPolicyHolderConvictionsForm
            sectionHeading={`Motor convictions`}
            showSectionHeading={false}
            data={data}
            onChange={handlers.onControlChange}
            
            addPolicyHolderConviction={addPolicyHolderConviction}
            handlePolicyHolderConvictionPropChange={handlePolicyHolderConvictionPropChange}
            removePolicyHolderConviction={removePolicyHolderConviction}
         />
         
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}